import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Button from "../../pageComponents/Settings/Free/Button";
import Store from "../../../assets/images/store.png";
import DiscountCodeHolder from "../../../assets/images/wood_dig_store.png";
import WoodiFrame from "../../../assets/images/woodi_framee.png";
import Tick from "../../../assets/images/tick.png";
import Exit from "../../../assets/images/exit.png";
import WoodenInput from "../Settings/Free/WoodenInput";
import axios from "axios";
import {offCode,buy} from "../../../Utility/Url";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "./Dialog";
import Dialog from "@material-ui/core/Dialog";
import PicoLoader from "./PicoLoader";
import {numberSplitor} from "../../../Utility/Func";


class ShopDialog extends React.Component{
    constructor(props) {
        super(props)
        this.state={
            toggle:false,
            dialogDetail:null,
            showDialog:false,
            data: (props.data),
            cln:null,
            pending:false,
            appliedDiscountCode:null,
            picoSmallLoader:false
        }
    }
    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     this.setState({
    //         cln:this.state.data
    //     })
    // }

    showResult=()=>{
        this.setState({showDialog:true})
    }
    handleInput=async (code)=>{
          this.setState({
              pending:true
          })
          await axios.post(offCode,{
              code:code
          })
              .then(res => {
                  this.setState({
                      pending:false
                  })
                  const {data}=res
                  if (!data.success){
                      const obg ={
                           success:false,
                               ok:null,
                               message:data.message,
                               style: {
                                   background: "red",
                                   borderColor: "‫‪#7b241c",
                                   contentColor: "#d98880",
                                   contentTextColor: "#ffffff",
                                   type: "danger",
                               },
                               cancel:{
                                   action: "#cancel",
                                   text: 'بستن'
                               }
                      }
                      this.setState({
                          dialogDetail:obg,
                      },this.showResult)
                  }
                  else{
                      let someProperty = {...this.state.data.data}
                      let currentPrice=this.state.data.data.dialog.price
                      let discountPercent=data.value
                      someProperty.dialog.fullPrice =currentPrice ;
                      someProperty.dialog.price = currentPrice - ((currentPrice * discountPercent)/100)
                      this.setState({
                          toggle:false,
                          someProperty,
                          appliedDiscountCode:code
                      })
                  }
              }).catch(error=>{
                      console.log(error.toString())
                  }
              )
    }
    pay= async(id)=>{
        this.setState({
            picoSmallLoader:true
        })
        const {appliedDiscountCode}=this.state
        await axios.post(buy,{
            code:!appliedDiscountCode?'':appliedDiscountCode,
            id:id
        })
            .then(res => {
                const {data}=res
                // this.setState({
                //     picoSmallLoader:false
                // })
                window.location.href=data.url
            }).catch(error=>{
                    console.log(error.toString())
                }
            )
    }
    toggleDiscount=()=>{
        this.setState({
            toggle:!this.state.toggle
        })
    }
    handleDialogAction=(action)=>{
        switch (action) {
            case '#cancel':
                this.setState({
                    showDialog:false,
                })
                break
            default:
                this.setState({
                    showDialog:false,
                })
        }
    }
    render() {
        const {button,data:{dialog:{icon,id,fullPrice,name,price}}}=(this.state.data)
        const okButton={
            text:'خرید',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderColor:'transparent',
        }
        const woodenInput={
            backgroundColor:'transparent',
            layerRadius:'15px',
            inputTextSize:'15px',
            inputMaxLength:'4',
            placeHolder:'*اختیاری',
            holderImage:DiscountCodeHolder,
            color:'red',
        }
        const {toggle,pending,picoSmallLoader}=this.state
        const {dialogDetail}=this.state
        const customDialog={
            button:{
                text:'',
                backgroundColor:'red',
                bottomFontSize:'15px',
                buttonTextColor:'red',
                borderColor:'transparent'
            },
            data:{
                dialog:dialogDetail,
            }
        }
        const handleClose=(()=>{
            this.setState({
                showDialog:false
            })
        })
        return (
            <Grid sm={12} xs={12} alignItems={"center"} container justify={"flex-end"}
                  className='dialog' style={{backgroundColor:'#b9bdba',border:'none',height:'100%',width:'100%'}}>
                <Dialog
                    // disableBackdropClick
                    open={this.state.showDialog}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',

                        },
                    }}
                >
                    <DialogContent>
                        <CustomDialog action={this.handleDialogAction} data={customDialog}/>
                    </DialogContent>
                </Dialog>

                <Grid sm={12} xs={12} alignItems={"center"} direction={"row"} style={{height:'50px',position:'relative',cursor:'none'}} container justify={"center"}>
                    <Button data={button}/>
                    <img src={Store} style={{width:'15%', bottom:'-50%',position:'absolute'}} alt=""/>
                </Grid>
                <Grid sm={11} xs={11} style={{backgroundColor:'',border:'none'}} direction={"row-reverse"} className='dialog-text-container' alignItems={"center"}  container justify={"center"}>
                    <Grid  sm={12} xs={12} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container style={{padding:'10px 0'}}>
                        <Grid sm={3} xs={3} container alignItems={"center"} justify={"center"}>
                            <img src={icon} style={{width:'100%'}} alt=""/>
                        </Grid>
                        <Grid direction={"column"} sm={5} xs={5} container alignItems={"center"} justify={"center"}>
                            <Grid item>
                                <p>
                                    {` خرید${name}`}
                                </p>
                            </Grid>
                            <Grid item>
                                <p style={{direction:'rtl'}}>
                                    {` تومان${numberSplitor(price)}`}
                                </p>
                            </Grid>
                            {
                                fullPrice != 0 &&
                                <Grid item>
                                <span className='offer-section-single-offer-span-outer'>
                                    <span className='offer-section-single-offer-span-inner' style={{color:'#ffffff'}}>
                                        {fullPrice!='0'?numberSplitor(fullPrice):''}
                                    </span>
                                </span>
                                </Grid>
                            }

                        </Grid>

                    </Grid>
                    <Grid  sm={12} xs={12} alignItems={"center"}  direction={"row-reverse"} justify={"center"} container>

                        {
                            toggle &&
                            <Grid className='clickable' sm={5} xs={5} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container >
                                {pending &&
                                    <p>
                                        درحال بررسی ...
                                    </p>
                                }
                                {!pending &&
                                <WoodenInput input={this.handleInput} data={woodenInput}/>
                                }
                            </Grid>
                        }

                            <Grid sm={9} xs={9} alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                  container>
                                { !picoSmallLoader &&
                                <Grid sm={12} className='clickable' xs={12} alignItems={"center"} justify={"center"}
                                      onClick={()=>{
                                          this.pay(id)
                                      }}
                                      container style={{height: '50px'}}>
                                    <Button data={okButton}/>
                                </Grid>
                                }
                                {
                                picoSmallLoader &&
                                <Grid sm={2} xs={2} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                      style={{position:'relative',height:'50px'}}
                                    >
                                    <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                        <PicoLoader/>
                                    </Grid>
                                </Grid>
                                }
                            </Grid>
                        {
                            fullPrice == 0 &&
                            <Grid  sm={12} xs={12} alignItems={"center"} direction={"row-reverse"}  justify={"center"} container
                                   style={{padding:'10px 0'}}
                                   onClick={()=>{
                                       this.toggleDiscount()
                                   }}
                            >
                                <Grid sm={1} xs={1} container alignItems={"center"} style={{position:'relative',backgroundColor:'darkBlue',borderRadius:'20px'}} justify={"center"}>
                                    <img src={WoodiFrame} style={{width:'100%'}} alt=""/>
                                    {
                                        toggle &&
                                        <img src={Tick} style={{width:'100%',position:'absolute'}} alt=""/>
                                    }
                                </Grid>
                                <Grid direction={"column"} sm={5} xs={5} container alignItems={"center"} justify={"center"}>
                                    <Grid item>
                                        <p style={{direction:'rtl'}}>
                                            کد تخفیف دارید ؟
                                        </p>
                                    </Grid>
                                </Grid>

                            </Grid>
                        }
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}
export default ShopDialog